import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import CodeMirror from 'react-codemirror';
import '../../../../node_modules/codemirror/mode/htmlmixed/htmlmixed.js';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class CustomHtml extends React.Component {
    constructor(props) {
        super(props);

        this.codeMirrorOptions = {
            lineNumbers: true,
            mode:'text/html',
        };

        this.el = this.el.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleHtmlChange = this.handleHtmlChange.bind(this);
    }


    el() {
        return this.props.builder.components[this.props.id];
    }

    renderSettings() {
        return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }

    handleBackClick() {
        this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
        this.props.setComponentState(this.el().id,{value:v+'px'});
    }

    handleHtmlChange(code) {
        this.props.setComponentState(this.el().id,{value:code});
    }


    render() {
        if(this.props.sidebar == true) {
            return(
                <div className="sidebar text" style={this.props.style}>
                    <SidebarElementHeader handleBackClick={this.handleBackClick} text="Custom HTML" />

                    <div className="alert dark alert-icon alert-warning" role="alert">
                        <i className="icon wb-alert" aria-hidden="true"></i> <strong>Warning:</strong> Advanced users only. Adding custom HTML could break email structure and can get rendering issues. Use at own risk.<br />
                        <br />
                        <strong>Adding clickable links to the html MAY result in lowered click tracking/conversion rate from Crall.</strong>
                    </div>

                    <CodeMirror value={this.el().value} onChange={this.handleHtmlChange} options={this.codeMirrorOptions} />
                </div>
            );
        }else{
            return (
                <div className="text main" dangerouslySetInnerHTML={{__html:this.el().value}} />
            );
        }

    }
}
const mapStateToProps = (state) => {
    return {
        builder:state.builder
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

CustomHtml = connect(mapStateToProps,mapDispatchToProps)(CustomHtml);

export default CustomHtml;





// WEBPACK FOOTER //
// ./components/builder/CustomHtml.js